import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Optional: for styling

const Navbar = () => {
    return (
        <nav className="app-navbar">
            {/*<nav className="app-navbar" style={{backgroundImage: `url(${logoImg})`}}>*/}
            <ul className="app-menu">
                {/*<li><Link to="/">Home</Link></li>*/}
                {/*<li><Link to="/about">About</Link></li>*/}
                {/*<li><Link to="/login">Login</Link></li>*/}
                <li>
                    <Link
                        to='https://www.facs.org/quality-programs/accreditation-and-verification/metabolic-and-bariatric-surgery-accreditation-and-quality-improvement-program/participant-use-data-file-puf/'
                        target="_blank">
                        MBSAQIP PUF User Guide
                    </Link>
                </li>
                <li>
                    <Link to='https://www.facs.org/quality-programs/accreditation-and-verification/metabolic-and-bariatric-surgery-accreditation-and-quality-improvement-program/' target="_blank">
                        MBSAQIP Website
                    </Link>
                </li>
                <li>
                    <Link to='https://www.facs.org/' target="_blank">
                        ACS Website
                    </Link>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;